import styled from 'styled-components';
import Navigation from '../Navigation';

const HeaderContainer = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background-color: ${props => props.theme.colors.cream};
  
  padding: 1rem 2rem;
  height: 80px;
`;

const HeaderSpacer = styled.div`
  height: 0px;
`;

function Header() {
  return (
    <>
      <HeaderContainer>
        <Navigation />
      </HeaderContainer>
      <HeaderSpacer />
    </>
  );
}

export default Header;
